import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { MilestoneCollaborationsFilters, MilestoneCollaborationSortOptions, MilestoneCollaborationStatus, MilestoneCollaborationStatusLabel, MilestoneCollaborationSortOptionLabel, MilestoneStepAssignee, MilestoneStepAssigneeLabel, MilestoneStepAssigneeColorCode } from 'types/collaboration';
import { debounce } from "lodash";
import { fetchAgencies } from 'services/api/collaboration';
import AsyncSelect from 'react-select/async';
interface MilestoneCollaborationFiltersProps {
    defaultFilters: MilestoneCollaborationsFilters,
    onApply: (updatedFilters: MilestoneCollaborationsFilters) => void
}

export const defaultFiltersValue = {
    page: 1,
    status: MilestoneCollaborationStatus.ONGOING,
    sort: MilestoneCollaborationSortOptions.LAST_ACTIVITY_AT
}

const Filters: React.FC<MilestoneCollaborationFiltersProps> = (
    {
        defaultFilters,
        onApply
    }) => {


    const [filters, setFilters] = useState<MilestoneCollaborationsFilters>(defaultFilters);
    const gigTypes = useSelector((state: RootState) => state.collaborations.gigTypes);
    const gigSteps = useSelector((state: RootState) => state.collaborations.gigSteps);

    useEffect(() => {
        setFilters(defaultFilters);
    }, [defaultFilters])

    const handleFilterChange = (key: string, value: MilestoneCollaborationSortOptions | MilestoneCollaborationStatus | string | {label: string, value: string}) => {
        setFilters({ ...filters, [key]: value });
    }

     const _loadAgenciesSuggestions = (query: string, callback: any) => {
        if (!query || query.length < 3) callback([]);

        fetchAgencies(query)
            .then(resp => callback(resp.map((item: any) => ({ value: item.uuid, label: item.name })))).catch(() => callback([]))
    };

    const loadAgenciesSuggestions = debounce(_loadAgenciesSuggestions, 200);

    return (
        <div className='filters-card'>
            <div className="p-4 pb-0">
                <div className="d-flex flex-column">
                    <span className="filter-title">Agency</span>
                    <AsyncSelect 
                        value={typeof filters.agency === 'string' ? null : filters.agency ?? null}
                        onChange={(val) => {
                            setFilters({...filters, agency: val ?? null, agency_id: val?.value})
                        }}
                        placeholder="Choose Agency"
                        menuPlacement='top'
                        cacheOptions
                        className='mt-2'
                        isClearable
                        loadOptions={loadAgenciesSuggestions}
                    />
                </div>
                <div className="d-flex flex-column mt-4">
                    <span className="filter-title">Status</span>
                    <div className="d-flex mt-2 gap-2 justify-content-start align-items-center flex-wrap">
                        {
                            Object.values(MilestoneCollaborationStatus).map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('status', filterVal)} className={`filters-badge ${filters.status === filterVal && 'active'}`}>{MilestoneCollaborationStatusLabel[filterVal]}</span>)
                        }
                    </div>
                </div>
                <div className="d-flex flex-column mt-4">
                    <span className="filter-title">Assignee</span>
                    <div className="d-flex mt-2 gap-2 justify-content-start align-items-center flex-wrap">
                        <span onClick={() => handleFilterChange('assignee', '')} className={`filters-badge  d-flex gap-1 align-items-center ${!filters.assignee && 'active'}`}>All</span>
                        {
                            Object.values(MilestoneStepAssignee).map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('assignee', filterVal)} className={`filters-badge  d-flex gap-1 align-items-center ${filters.assignee === filterVal && 'active'}`}> <span className={`color-block bg-${MilestoneStepAssigneeColorCode[filterVal]}`}></span> {MilestoneStepAssigneeLabel[filterVal]}</span>)
                        }
                    </div>
                </div>
                <div className="d-flex flex-column mt-4">
                    <span className="filter-title">Has Started?</span>
                    <div className="d-flex mt-2 gap-2 justify-content-start align-items-center flex-wrap">
                        {
                            ['y', 'n'].map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('has_processed_steps', filterVal)} className={`filters-badge ${filters.has_processed_steps === filterVal && 'active'}`}>{filterVal === 'y' ? 'Yes' : 'No'}</span>)
                        }
                    </div>
                </div>
                <div className="d-flex flex-column mt-4">
                    <span className="filter-title">Gig Type</span>
                    <select className='form-select mt-2' value={filters.gig_type ?? ''} onChange={(e) => handleFilterChange('gig_type', e.target.value) }>
                        <option value="">Select</option>
                        {
                            gigTypes.map((gigType, i) => <option key={i} value={gigType.slug}>{gigType.name}</option> )
                        }
                    </select>
                </div>
                <div className="d-flex flex-column mt-4">
                    <span className="filter-title">Gig Step</span>
                    <select className='form-select mt-2' value={filters.gig_step ?? ''} onChange={(e) => handleFilterChange('gig_step', e.target.value) }>
                        <option value="">Select</option>
                        {
                            gigSteps.map((gigStep, i) => <option key={i} value={gigStep.slug}>{gigStep.name}</option> )
                        }
                    </select>
                </div>
                <div className="d-flex flex-column mt-4">
                    <span className="filter-title">Sort By</span>
                    <div className="d-flex mt-2 gap-2 justify-content-start align-items-center flex-wrap">
                        {
                            Object.values(MilestoneCollaborationSortOptions).map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('sort', filterVal)} className={`filters-badge ${filters.sort === filterVal && 'active'}`}>{MilestoneCollaborationSortOptionLabel[filterVal]}</span>)
                        }
                    </div>
                </div>
            </div>
            <div className="divider mt-4"></div>
            <div className="d-flex justify-content-end align-items-center gap-3 px-4 py-3">
                <button className="theme-btn btn-primary-outlined" onClick={() => onApply({ ...defaultFiltersValue})}>Reset</button>
                <button className='theme-btn btn-primary' onClick={() => onApply(filters)}>Apply</button>
            </div>
        </div>
    )
}

export default Filters